// Add to Cart Modal - Collection Page Functionality
// Handles variant selection, tapas selector, and cart integration

document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('add-to-cart-modal');
  if (!modal) return;

  const modalContainer = modal.querySelector('.atc-modal__container');
  const modalTitle = modal.querySelector('.atc-modal__title');
  const modalPrice = modal.querySelector('.atc-modal__price');
  const modalVariants = modal.querySelector('#modal-variants');
  const modalVariantButtons = modal.querySelector('#modal-variant-buttons');
  const modalServingInfo = modal.querySelector('#modal-serving-info');
  const modalTapasSelector = modal.querySelector('#modal-tapas-selector');
  const modalTapasWidgetContainer = modal.querySelector('#modal-tapas-widget-container');
  const modalQuantityInput = modal.querySelector('#modal-quantity');
  const modalAddButton = modal.querySelector('#modal-add-to-cart');

  let currentProduct = null;
  let selectedVariantId = null;
  let tapasWidget = null;

  // Use global data (injected by theme.liquid from centralized sources)
  const servingSizes = window.SERVING_SIZES || {};
  const tapasOptions = window.TAPAS_OPTIONS || [];

  // Product handles and configurations for tapas products
  const TAPAS_PRODUCTS = {
    'tapas-sampler-6-compartment-container': { maxSelections: 6 },
    'individual-32-oz-tapas': { maxSelections: 1 }
  };

  // Helper to check if product is a tapas product
  function getTapasConfig(productHandle) {
    return TAPAS_PRODUCTS[productHandle] || null;
  }

  // Get serving size for variant
  function getServingSize(variantTitle) {
    const normalized = variantTitle.toLowerCase().trim();
    // Check larger numbers first to avoid false matches (e.g., 160 before 60)
    const sortedKeys = Object.keys(servingSizes).sort((a, b) => {
      const aNum = parseInt(a) || 0;
      const bNum = parseInt(b) || 0;
      return bNum - aNum;
    });

    for (const key of sortedKeys) {
      if (normalized.includes(key)) {
        return servingSizes[key];
      }
    }
    return '';
  }

  // Format money
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Open modal
  function openModal() {
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  // Close modal
  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    resetModal();
  }

  // Reset modal state
  function resetModal() {
    currentProduct = null;
    selectedVariantId = null;
    tapasWidget = null;
    modalQuantityInput.value = 1;
    modalVariants.style.display = 'none';
    modalServingInfo.style.display = 'none';
    modalTapasSelector.style.display = 'none';
    modalTapasWidgetContainer.innerHTML = '';
    // Remove wide class
    if (modalContainer) {
      modalContainer.classList.remove('atc-modal__container--wide');
    }
  }

  // Fetch product data from Shopify
  async function fetchProduct(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) {
        console.error('Error fetching product: Product not found');
        window.showToast('Unable to load product details. Please try again.', 'error');
        return null;
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching product:', error);
      window.showToast('Unable to load product details. Please try again.', 'error');
      return null;
    }
  }

  // Render variant buttons
  function renderVariants(product) {
    // Hide variant selector for single-variant products (any title)
    if (product.variants.length === 1) {
      modalVariants.style.display = 'none';
      selectedVariantId = product.variants[0].id;
      return;
    }

    modalVariants.style.display = 'block';
    modalVariantButtons.innerHTML = '';

    product.variants.forEach((variant, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'atc-modal__variant-btn' + (index === 0 ? ' active' : '');
      button.dataset.variantId = variant.id;
      button.dataset.variantTitle = variant.title;
      button.dataset.variantPrice = variant.price;

      const variantDisplay = variant.title.replace(/1\/2 Tray/g, 'Half Tray');
      button.innerHTML = `
        <span class="atc-modal__variant-title">${variantDisplay}</span>
        <span class="atc-modal__variant-price">${formatMoney(variant.price)}</span>
      `;

      button.addEventListener('click', function() {
        // Update active state
        modalVariantButtons.querySelectorAll('.atc-modal__variant-btn').forEach(btn => {
          btn.classList.remove('active');
        });
        this.classList.add('active');

        // Update selected variant
        selectedVariantId = parseInt(this.dataset.variantId);

        // Update serving info
        updateServingInfo(this.dataset.variantTitle);
      });

      modalVariantButtons.appendChild(button);
    });

    // Set initial variant
    selectedVariantId = product.variants[0].id;
    updateServingInfo(product.variants[0].title);
  }

  // Update serving info
  function updateServingInfo(variantTitle) {
    const servingSize = getServingSize(variantTitle);

    if (servingSize) {
      modalServingInfo.textContent = servingSize;
      modalServingInfo.style.display = 'block';
    } else {
      modalServingInfo.style.display = 'none';
    }
  }

  // Render visual tapas selector widget
  function renderTapasSelector(maxSelections) {
    if (!window.TapasSelector) {
      console.error('TapasSelector component not loaded');
      return;
    }

    modalTapasSelector.style.display = 'block';

    // Make modal wider for tapas selector
    if (modalContainer) {
      modalContainer.classList.add('atc-modal__container--wide');
    }

    modalTapasWidgetContainer.innerHTML = window.TapasSelector.buildHTML(tapasOptions, maxSelections, 'modal-tapas');
    window.TapasSelector.initialize(modalTapasWidgetContainer);

    // Store reference to the widget API
    tapasWidget = modalTapasWidgetContainer.tapasSelector;
  }

  // Add to cart
  async function addToCart() {
    if (!selectedVariantId) {
      window.showToast('Please select a size.', 'warning');
      return;
    }

    // Check if this is a tapas product
    const tapasConfig = getTapasConfig(currentProduct.handle);

    if (tapasConfig) {
      if (!tapasWidget || !tapasWidget.isFull()) {
        const selectionsText = tapasConfig.maxSelections === 1 ? '1 tapas' : tapasConfig.maxSelections + ' tapas';
        window.showToast('Please select exactly ' + selectionsText + '.', 'warning');
        return;
      }
    }

    // Prevent double-click during async operation
    modalAddButton.disabled = true;

    const quantity = parseInt(modalQuantityInput.value) || 1;

    const formData = {
      id: selectedVariantId,
      quantity: quantity
    };

    // Add line item properties for tapas products
    if (tapasConfig && tapasWidget) {
      const selections = tapasWidget.getSelections();
      if (selections.length > 0) {
        formData.properties = {
          'Tapas Selections': selections.join(', ')
        };
      }
    }

    // Use CartManager's queue to prevent rate limiting
    if (window.cartManagerInstance) {
      try {
        await window.cartManagerInstance.queueRequest(async () => {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
          });

          if (!response.ok) {
            throw new Error(`Failed to add to cart: ${response.status}`);
          }

          return await response.json();
        });

        // Show success message
        if (window.showToast) {
          window.showToast('Item added to cart!', 'success', 2000);
        }

        // Close modal
        closeModal();

        // Open cart drawer (refreshCart called internally by openCart)
        await window.cartManagerInstance.openCart(true);

      } catch (error) {
        console.error('Error adding to cart:', error);

        // Provide specific error message based on error type
        let errorMessage = 'Unable to add item to cart. Please try again.';
        if (error.message && error.message.includes('Failed to fetch')) {
          errorMessage = 'Connection issue. Please check your internet and try again.';
        } else if (error.message && error.message.includes('429')) {
          errorMessage = 'Please wait a moment before adding more items.';
        }

        window.showToast(errorMessage, 'error');
      } finally {
        modalAddButton.disabled = false;
      }
    } else {
      // Fallback if CartManager not available
      console.error('CartManager not available');
      modalAddButton.disabled = false;
      window.location.reload();
    }
  }

  // Handle Add to Cart button clicks on collection page
  document.addEventListener('click', async function(e) {
    const addButton = e.target.closest('.product-card__add-btn');
    if (!addButton) return;

    e.preventDefault();
    e.stopPropagation();

    const productHandle = addButton.dataset.productHandle;
    if (!productHandle) return;

    // Show loading state
    addButton.classList.add('loading');

    // Fetch product data
    const product = await fetchProduct(productHandle);

    // Hide loading state
    addButton.classList.remove('loading');

    if (!product) return;

    currentProduct = product;

    // Set modal title and price
    modalTitle.textContent = product.title;
    modalPrice.textContent = formatMoney(product.price);

    // Check if this is a tapas product
    const tapasConfig = getTapasConfig(product.handle);

    if (tapasConfig) {
      // Show tapas selector instead of variants
      modalVariants.style.display = 'none';
      selectedVariantId = product.variants[0].id; // Set default variant
      renderTapasSelector(tapasConfig.maxSelections);
    } else {
      // Show variants
      renderVariants(product);
    }

    // Open modal
    openModal();
  });

  // Close modal handlers
  modal.querySelectorAll('[data-modal-close]').forEach(closeBtn => {
    closeBtn.addEventListener('click', closeModal);
  });

  // Quantity controls
  modal.querySelector('[data-modal-qty-decrease]').addEventListener('click', function() {
    const currentValue = parseInt(modalQuantityInput.value) || 1;
    if (currentValue > 1) {
      modalQuantityInput.value = currentValue - 1;
    }
  });

  modal.querySelector('[data-modal-qty-increase]').addEventListener('click', function() {
    const currentValue = parseInt(modalQuantityInput.value) || 1;
    modalQuantityInput.value = currentValue + 1;
  });

  // Add to cart button
  modalAddButton.addEventListener('click', addToCart);

  // Keyboard support - close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });
});
